// @ts-ignore
import styles from './VideoFolder.module.scss';
import { useState } from 'react';
import { joinClasses } from '../../../Utils/className.util';

interface VideoFolder {
	title: string;
	active?: boolean;
}

export default function VideoFolder(props: VideoFolder) {
	const { title, active } = props;

	return (
		<div className={joinClasses([styles.wrapper, active && styles.active])}>
			<div className={'d-flex flex-row align-items-center'}>
				<div className={styles.icon} />
				<div className={styles.title}>{title}</div>
			</div>
		</div>
	);
}
